// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_BUYER_buyer_HAS_NOT_READ_YET = "%(buyer)s si zatia\u013e nepre\u010d\u00edtala";
export const BZ2_BUYER_buyer_READ_THE_MESSAGE_ON_date = "%(buyer)s si pre\u010d\u00edtala %(date)s";
export const BZ2_BUYER_HAS_NOT_READ_YET = "Zatia\u013e nepre\u010d\u00edtan\u00e9";
export const BZ2_BUYER_READ_THE_MESSAGE_ON_date = "Pre\u010d\u00edtala %(date)s";
export const BZ2_SELLER_HAS_NOT_READ_YET = "Zatia\u013e nepre\u010d\u00edtan\u00e9";
export const BZ2_SELLER_READ_THE_MESSAGE_ON_date = "Pre\u010d\u00edtala %(date)s";
export const BZ2_SELLER_seller_HAS_NOT_READ_YET = "%(seller)s si zatia\u013e nepre\u010d\u00edtala";
export const BZ2_SELLER_seller_READ_THE_MESSAGE_ON_date = "%(seller)s si pre\u010d\u00edtala %(date)s";
